<template>
  <dashboard-panel
    title="Key Document"
    icon="fa-key"
    :count="keyDocumentTotal"
    add-label="add key document"
    :add-permissions="['can_add_key_document']"
    :loading="isFetching"
    :empty="!keyDocuments.data || keyDocuments.data.length == 0"
    empty-text="No key documents found"
    :pager="keyDocuments"
    :busy="busy"
    @add="$refs.addKeyDocument.$refs.modal.open()"
    @page="goToPage"
  >
    <dashboard-list-item
      v-for="keyDocument in keyDocuments.data"
      :key="keyDocument.id"
      :author="creatorName(keyDocument.user)"
      :date="keyDocument.updated_at"
      :title="keyDocument.title"
      :body="keyDocument.description"
      @click="viewKeyDocument(keyDocument)"
    ></dashboard-list-item>

    <template #modals>
      <add-key-document
        :vault="vault"
        @processing="processing"
        @getKeyDocuments="getKeyDocuments"
        ref="addKeyDocument"
      ></add-key-document>

      <view-key-document
        :vault="vault"
        :selectedKeyDocument="selectedKeyDocument"
        @processing="processing"
        @getKeyDocuments="getKeyDocuments"
        ref="viewKeyDocument"
      ></view-key-document>
    </template>
  </dashboard-panel>
</template>

<script>
import axios from "axios";
import * as Sentry from "@sentry/vue";
import DashboardPanel from "./DashboardPanel.vue";
import DashboardListItem from "./DashboardListItem.vue";
import AddKeyDocument from "./KeyDocument/Add.vue";
import ViewKeyDocument from "./KeyDocument/View.vue";

export default {
  name: "KeyDocument",

  props: ["vault"],

  components: {
    DashboardPanel,
    DashboardListItem,
    AddKeyDocument,
    ViewKeyDocument,
  },

  data() {
    return {
      isFetching: false,
      busy: false,

      keyDocuments: {},

      keyDocumentTotal: 0,

      selectedKeyDocument: {},

      searchParams: {
        page: 1,
        perPage: 10,
      },
    };
  },

  mounted() {
    this.getKeyDocuments();
  },

  methods: {
    getKeyDocuments() {
      this.keyDocuments = {};

      this.isFetching = true;

      axios
        .get(`api/vaults/${this.vault.id}/key-documents`, {
          params: {
            page: this.searchParams.page,
            per_page: this.searchParams.perPage,
          },
        })
        .then(({ data }) => {
          this.keyDocuments = data;
          this.keyDocumentTotal = data.total;
          this.isFetching = false;
        })
        .catch((err) => {
          Sentry.captureException(err);
          this.isFetching = false;
        });
    },

    goToPage(page) {
      this.searchParams.page = page;
      this.getKeyDocuments();
    },

    viewKeyDocument(keyDocument) {
      this.selectedKeyDocument = keyDocument;
      this.$nextTick(() => {
        this.$refs.viewKeyDocument.$refs.modal.open();
      });
    },

    // toggle the blocking spinner
    processing(isProcessing) {
      this.busy = isProcessing;
    },

    creatorName(user) {
      if (!user) {
        return "-";
      }
      return `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim();
    },
  },
};
</script>
